import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactModal from 'react-modal';
import PassengerDropdown from '../../departure/components/passengerdropdown';
import BuilderCard from './components/builder-card';
import BookingSummary from '../../departure/basketsummary';
import { SetDeparture } from '../../../actions/currentBooking';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import DestinationPanel from './components/destination-panel';
import { RemoveReservationsPayload, RemoveTripPayload } from '../../../helpers/bookingHelper';
import { DeleteTripInfo } from '../../../actions/booking';
import { FetchIntineraries, PostIntinerariesAccomodation } from '../../../actions/itineraries';
import Spinner from '../../shared/spinner';
import Sticky from 'react-stickynode';
import _filter from 'lodash/filter';
import { sectorWithImagesAndInfo } from '../../../helpers/cyoaHelper';
import { CYOA_NETWORK_IDS } from '../../../config';
const queryString = require('query-string');
const qs = queryString.parse(window.location.search);

class EditTrip extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      promptIsOpen:false,
      closeTourId:"",
      showStartAgainPrompt:false
    }
    this.openPromptModal = this.openPromptModal.bind(this);
    this.closePromptModal = this.closePromptModal.bind(this);
    this.confirmPromptModal = this.confirmPromptModal.bind(this);
    this.onCloseClicked = this.onCloseClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
  }

  openPromptModal(){ this.setState({promptIsOpen:true}); }
  closePromptModal(){ this.setState({promptIsOpen:false}); }
  onBackClicked(){

    const {
      history,
      itineraries,
      itineraries:{accomm_global_room_type},
      PostIntinerariesAccomodation
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_PAGE}?id=${qs.id}`);


    PostIntinerariesAccomodation(itineraries, true, true, (accomm_global_room_type === "none" ? false : true), accomm_global_room_type);

  }

  componentDidMount(){

    const {
      SetDeparture,
      FetchIntineraries,
      itineraries
    } = this.props;


    // Scroll window to top
    window.scrollTo(0, 0);

    //Populate departure from booking response or FetchIntineraries
    if(itineraries !== undefined){
      SetDeparture(itineraries.content.date_start);
    }else{
      FetchIntineraries(qs.id);
    }

  }


  componentDidUpdate(prevProp, prevState){

    const {
      SetDeparture,
      history,
      itineraries
    } = this.props;


    if(itineraries !== prevProp.itineraries){

      //check payment exist - redirect back
      if(itineraries.total_paid !== "0.00"){
        history.push(`${process.env.REACT_APP_ITINERARY_PAGE}?id=${qs.id}`);
      }

      //Populate departure from booking response
      SetDeparture(itineraries.content.date_start);

    }

  }


  onCloseClicked(tourId, index){

    //show close prompt or start new itinerary prompt
    this.setState({
      closeTourId:tourId,
      showStartAgainPrompt:index === 1 ? true : false
    });
    this.openPromptModal();
  }

  confirmPromptModal(){

    const { DeleteTripInfo, itineraries, itineraries:{ tms_group_booking_id } } = this.props;
    const { closeTourId, showStartAgainPrompt  } = this.state;
    
    if(showStartAgainPrompt){
      window.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_PAGE}`;
    }else{

      //CHECK IF TOUR OR SECTOR AND DELETE ACCORDINGLY
      const isCyoaID = (closeTourId === CYOA_NETWORK_IDS["europe"].id || closeTourId === CYOA_NETWORK_IDS["usa"].id);
      const REQUEST_TYPE = (isCyoaID) ? "remove_sectors" : "remove_trips";
      const PAYLOAD = (isCyoaID) ? RemoveReservationsPayload(itineraries, closeTourId) : RemoveTripPayload(itineraries, closeTourId);

      DeleteTripInfo(tms_group_booking_id, REQUEST_TYPE, PAYLOAD).then(()=>{
        this.closePromptModal();
      });
      
    }
  }


  render(){

    const { promptIsOpen, showStartAgainPrompt } = this.state;
    const { itineraries } = this.props;
    const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : [];

    if(_itineraries.length === 0){
      return <Spinner text="Loading your adventure..." loadClass="orange-spinner-wrapper" />
    }else{

    const { isUpdating, itineraries, itineraries:{iso_currency, sectors, content:{nr_pax}} } = this.props;
    const price = parseInt(_filter(itineraries.sectors, ['type', 'sector'])[0].transfer.price, 10)

      return (
        <Fragment>

          <button className="lity-close" onClick={this.onBackClicked}>×</button>

          <div className="builder">
            <div className="row margin-t-50">
              <div className="column small-12">
                <div className="builder-text">
                  <h4 className="busabout-h4 uppercase">Update Trip</h4>
                  <p className="no-margin">
                    Add a destination
                    <span className="orange-text"> for {ISOCurrencyCovert(iso_currency)}{price} per stop</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="row margin-t-40">
              <div className="column small-12 medium-7 large-8">

                <PassengerDropdown iscyoa={true} disabled={true} paxnum={nr_pax} />

                <ul className="builder-list">
                  {
                    sectorWithImagesAndInfo(itineraries).map((data, index) => {
                      return (
                        <li key={index} className={`builder-list-item builder-list-item-card ${(sectors.length === index + 1 )? 'last': ''}`}>
                          <BuilderCard
                            id={'edit-view'}
                            showClose={true}
                            showPlus={false}
                            onCloseClicked={this.onCloseClicked}
                            sequence={data}
                            index={index}
                            sectors={sectors}
                            type={data.type}
                            currency={ISOCurrencyCovert(iso_currency)}
                          />
                        </li>
                      )
                    })
                  }
                  <li className="builder-list-item">
                    <DestinationPanel promptIsOpen={promptIsOpen} id={'edit-view'} />
                  </li>
                </ul>

              </div>
              <div className="column small-12 medium-5 large-4">
                <Sticky enabled={true} top={50} innerZ={999998}>
                  <BookingSummary title="Summary" basketsummaryclass="builder" basketType="cyoa" iscyoa={true} isedit={true} closeEdit={this.onBackClicked} />
                </Sticky>
              </div>
            </div>
          </div>

          <ReactModal
            className="error-modal builder"
            overlayClassName="modal-overlay semi-white"
            isOpen={promptIsOpen}
            onRequestClose={this.closePromptModal}
            contentLabel="Edit Prompt modal">

            <div className="error-modal-container">
              <div className="row">
                <div className="column small-12">
                  <p className="ba-icon ba_icon_extra_info_alt"></p>
                  <p className="wait-text">Hey Wait!</p>
                  <p>
                    <span style={{display: showStartAgainPrompt ? 'none' : 'inline' }}>Are you sure you want to remove this city?</span>
                    <span style={{display: showStartAgainPrompt ? 'inline' : 'none' }}>Are you sure you want to start a new itinerary?</span>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="column small-12 text-center">
                    <button type="button" className="busabout--cta orange back-search" onClick={this.confirmPromptModal}>
                      <span style={{display:isUpdating ? "none" : "block"}}>confirm</span>
                      <span style={{display:isUpdating ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
                    </button>
                </div>
              </div>
              <button className="modal-close orange" onClick={this.closePromptModal}>
                &#x2715;
              </button>
            </div>
          </ReactModal>
        </Fragment>
      )
    }
  }


}


function mapStateToProps(state){
  return {
    isUpdating:state.bookingGroup.updating,
    editDaysCapacity:state.editDaysCapacity,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetDeparture,
    DeleteTripInfo,
    FetchIntineraries,
    PostIntinerariesAccomodation
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTrip);



// WEBPACK FOOTER //
// ./src/components/itinerary/editTrip/index.js